import _ from 'underscore';

export const getDatePickerStrings = i18n => ({
  months: _.range(1, 13).map(num => i18n.getMonth(num, { style: 'wide' })),
  shortMonths: _.range(1, 13).map(num => i18n.getMonth(num, { style: 'abbreviated' })),
  days: _.map(
    ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
    day => i18n.getDayOfWeek(day, { style: 'wide' })
  ),
  shortDays: _.map(
    ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
    day => i18n.getDayOfWeek(day, { style: 'narrow' })
  ),
  goToToday: i18n.getString(_TL_('Go to today')),
  prevMonthAriaLabel: i18n.getString(_TL_('Go to previous month')),
  nextMonthAriaLabel: i18n.getString(_TL_('Go to next month')),
  prevYearAriaLabel: i18n.getString(_TL_('Go to previous year')),
  nextYearAriaLabel: i18n.getString(_TL_('Go to next year')),
  closeButtonAriaLabel: i18n.getString(_TL_('Close date picker')),
  isRequiredErrorMessage: i18n.getString(_TL_('Start date is required.')),
  invalidInputErrorMessage: i18n.getString(_TL_('Invalid date format.')),
});
